import { render, staticRenderFns } from "./ui-box.vue?vue&type=template&id=376a97fd&scoped=true&"
import script from "./ui-box.vue?vue&type=script&lang=js&"
export * from "./ui-box.vue?vue&type=script&lang=js&"
import style0 from "./ui-box.vue?vue&type=style&index=0&id=376a97fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a97fd",
  null
  
)

export default component.exports